import { TicketCard } from "@/molecules/TicketCard"
import { ActionCollapse } from "./ActionCollapse"
import { ActionLabel } from "./ActionLabel"
import { ActionListCard } from "./ActionListCard"
import { ActionsCount } from "./ActionsCount"

import type { ActionCardComponent } from "."

export const ActionCard: ActionCardComponent = ({ ticket, type, aside }) => (
  <TicketCard
    ticketKey={ticket.name}
    ticketUrl={ticket.url}
    type={type}
    aside={aside}
  />
)

ActionCard.List = ActionListCard
ActionCard.Collapse = ActionCollapse
ActionCard.Count = ActionsCount
ActionCard.Label = ActionLabel
